import { render, staticRenderFns } from "./SelectV2.vue?vue&type=template&id=572f37de&"
import script from "./SelectV2.vue?vue&type=script&lang=js&"
export * from "./SelectV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\ele-dynamic-form\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('572f37de')) {
      api.createRecord('572f37de', component.options)
    } else {
      api.reload('572f37de', component.options)
    }
    module.hot.accept("./SelectV2.vue?vue&type=template&id=572f37de&", function () {
      api.rerender('572f37de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/SelectV2.vue"
export default component.exports